require('jquery-mask-plugin');
require('../components/ajax-form');
require('../components/masks');
import winners from '../components/winners';
import cellar from '../components/cellar';
import featuredSlider from '../components/featured-slider';
import conditionalComponent from '../components/conditional-component';

export default {
  init() {
    cellar.fire();
    winners.fire();
    featuredSlider.fire();
    conditionalComponent.fire();
    require('webfontloader').load({
      google: {
        families: ['Lato:300,400,700', 'Raleway:400,700'],
      },
    });
    $('select.select-redirect').change(function () {
      let $option = $(this).find('option:selected');
      let url = $option.val();
      let target = $option.data('target');

      if (! url) return;

      let link = document.createElement('a');

      link.href = url;
      link.target = target;

      document.body.appendChild(link);

      link.click();
    });
    let checkActive = function (control) {
      let item = control.parents('.wpcf7-form-control-wrap').siblings('small');

      item.toggleClass('active', !!control.val() || control.is(':focus'));
    };
    $('.wpcf7-form .form-control').each(function () {
      checkActive($(this));
    });
    $('body').on('keydown keyup focus blur', '.wpcf7-form .form-control', function () {
      checkActive($(this));
    });
    var SPMaskBehavior = function (val) {
      return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    };
    var spOptions = {
      onKeyPress: function(val, e, field, options) {
        field.mask(SPMaskBehavior.apply({}, arguments), options);
      },
    };
    $('.mask-phone').mask(SPMaskBehavior, spOptions);
  },

  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js